import { StructureExportDto } from '@/endpoints/models'

export const TREE_INDENT_PX = 18

export type TypeCounts = Record<string, number>

export const NON_VISIBLE_TYPES = new Set<string>(['ROOT', 'TABLE_COLUMN'])

export function countTypes(node: StructureExportDto, acc: TypeCounts): TypeCounts {
	const type = node.type ?? 'ROOT'
	acc[type] = (acc[type] ?? 0) + 1
	node.children?.forEach((child) => countTypes(child, acc))
	return acc
}

export function getStructureNodeKey(
	node: StructureExportDto,
	depth: number,
	index: number,
): string {
	const identity = node.code ?? node.name ?? `unnamed-${index}`
	return `${node.type ?? 'ROOT'}-${identity}-${depth}`
}
